module.exports = __webpack_public_path__ + "img/night-bg-img.dca4d3a7.jpg";